import superMeta from '../_ALG_CAT/metaAlgCatNode.mjs'

export default {
    ...superMeta,
    algNodeType: 'BDALG',
    algType: 'DEVELOP',
    name: '业务事务方法',
    type: 'BD_DEVELOP',
}
